module.exports = __webpack_public_path__ + "static/img/2.be7badf.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/1/zh/2.png
// module id = pCou
// module chunks = 0